import React from 'react';
import { useSelector } from 'react-redux'
import { Col, Container, Row } from 'react-bootstrap';
import PageHeader from '../../components/pageHeader/pageHeader.component';
import AlbumCard from '../../components/albumCard/albumCard.component';
import Loading from '../../components/layouts/Loading'
import { bucket_url } from '../../constants/const'

import VideoGalleryPageCover from '../../assets/images/banners/video-album.png';

const VideoGalleryPage = props => {

    const { loading, videoAlbums } = useSelector(state => state.all)

    return (
        <div>
            <PageHeader
                title="ভিডিও অ্যালবাম"
                cover={VideoGalleryPageCover}
            >
                <p>
                    কঠিন বিষয়গুলো সহজে মনে রাখা জন্য Tricks শেখানো হয়। একইসাথে অধিক গুরুত্বপূর্ণ অংশগুলো চিহ্নিত করতে লাল
                    সবুজ কালিতে বই দাগানো হয়ে থাকে।
                </p>
            </PageHeader>
            <section className="photo-album-section py-5 border-top border-bottom bg-light">
                <Container>
                    {loading ? <Loading /> : (
                        <Row>
                            {videoAlbums && videoAlbums.map(item => (
                                <Col xs={12} md={4}>
                                    <AlbumCard
                                        title={item.name}
                                        cover={`${bucket_url}${item.coverPhoto}`}
                                        href={`/gallery/videos/${item._id}`}
                                        video
                                    />
                                </Col>
                            ))}
                        </Row>
                    )}
                </Container>
            </section>
        </div>
    )
}

export default VideoGalleryPage;